import React from "react";
import { Row, Col, Input, Select, Button, Form } from "antd";

const { Option } = Select;

const AnnouncementFilters = ({ filters, onFiltersChange }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    onFiltersChange(values);
  };

  const handleReset = () => {
    form.resetFields();
    onFiltersChange({});
  };

  return (
    <Form form={form} name="announcement_filters" onFinish={onFinish} layout="inline" initialValues={filters}>
      <Row gutter={[16, 16]} style={{ width: "100%" }}>
        <Col xs={24} sm={12} md={6}>
          <Form.Item name="language" label="Language" style={{ width: "100%" }}>
            <Select placeholder="Select Language" allowClear>
              <Option value="en">English</Option>
              <Option value="ms">Malay</Option>
              <Option value="zh">Chinese</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Form.Item name="isAnnouncement" label="Active" style={{ width: "100%" }}>
            <Select placeholder="All" allowClear>
              <Option value="true">Yes</Option>
              <Option value="false">No</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
              Filter
            </Button>
            <Button onClick={handleReset}>Reset</Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default AnnouncementFilters;
